import { store } from '@betacrew/jars-flux';
import { all, put, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { PAGE_STATE } from '../../../constants/constants';
import { componentKey, setLoadingState, setTinMatchFees, setTinMatchFinalReportModalOpen } from "./TinMatchSlice"
import RecipientDataService from '../../../../../services/RecipientDataService';
import { setRequestedCount, setTinMatchConfirmationModalOpen, setTinMatchForAllRecipientsModalOpen } from './TinMatchSlice';
import Payer from '../../../../../libs/utility/Payer';
import { TIN_MATCH_MODALS_LOADING_STATE } from './constants';
import General from '../../../../../libs/utility/General';

export const { getRequestedCount, getTinMatchFee } = {

    getRequestedCount: (payload) => {
        return {
            type: "TIN_MATCH/GET_REQUESTED_COUNT",
            payload
        }
    },

    getTinMatchFee: (payload) => {
        return {
            type: "TIN_MATCH/GET_TIN_MATCH_FEE",
            payload
        }
    }
}

function* getRequestedCountAsync(action) {
    try {
        yield put(setLoadingState({ state: TIN_MATCH_MODALS_LOADING_STATE.GET_REQUESTED_COUNT_LOADING }))

        const { PayerID, RecipientIds, IsAllSelect } = action.payload;

        const params = {
            PayerID: PayerID || "",
            RecipientIds: RecipientIds || [],
            IsAllSelect: IsAllSelect,
        }

        const response = yield RecipientDataService.getRequestedCount(params);

        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setRequestedCount({
                TinMatchingRequests: Data,
                AcceptedRequests: General.extractPaginationTotalFromResponse(response.data) || 0
            }))
            yield put(setTinMatchConfirmationModalOpen(false))
            yield put(setTinMatchForAllRecipientsModalOpen(true))
        } else {
            yield put(addNotifications({ heading: "Error", message: "Failed to get the requested Count" }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the requested Count", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: TIN_MATCH_MODALS_LOADING_STATE.GET_REQUESTED_COUNT_READY }))
    }

}

function* getTinMatchFeeAsync(action) {
    try {
        yield put(setLoadingState({ state: TIN_MATCH_MODALS_LOADING_STATE.GET_TIN_MATCH_FEE_LOADING }));
        
        const response = yield RecipientDataService.getTinMatchFilingFee(action?.payload);
        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setTinMatchFees(Data));
            yield put(setTinMatchFinalReportModalOpen(true))
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the TIN match fee", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: TIN_MATCH_MODALS_LOADING_STATE.GET_TIN_MATCH_FEE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getRequestedCount().type, getRequestedCountAsync),
        takeLatest(getTinMatchFee().type, getTinMatchFeeAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);